import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import RootComponent from './RootComponent'
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { HelmetProvider } from "react-helmet-async";
import { persistor, store } from './store/reducers/store'
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./input.css"
// import "./output.min.css"
import { initGA } from './utils/analytics';



const App: React.FC = () => {

    console.log("App Mode:", process.env.REACT_APP_ENV);
    console.log("App REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);

    useEffect(() => {
        initGA();
    }, []);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
            <HelmetProvider>
                <BrowserRouter> {/* Wrap RootComponent with BrowserRouter */}
                    <RootComponent />
                </BrowserRouter>
                </HelmetProvider>
            </PersistGate>
        </Provider>
    )
}

export default App
